import { toast } from 'react-toastify';

export const getParamFromUrl = param => {
	const windowUrl = window?.location?.search;
	const params = new URLSearchParams(windowUrl);

	return params.get(param);
};

export const toFixedNoRounding = (num, fixed) => {
	var regex = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
	return num.toString().match(regex)[0];
};

export const showErrorToast = message => {
	toast.error(message, {
		position: 'top-center',
		autoClose: 3000,
		theme: 'colored',
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: false,
		progress: undefined,
	});
};
